import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import { ApiData } from "./config"

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      errors: {},
      username: '',
      password: '',
    };
  }

  componentDidMount() {
  }

  handleLoginValidation() {
    let errors = {};
    let formIsValid = true;

    if (!this.state.username) {
      formIsValid = false;
      errors['username'] = '*';
    }
    if (!this.state.password) {
      formIsValid = false;
      errors['password'] = 'Password is Required';
    }
    this.setState({ errors: errors });
    return formIsValid;
  }

  Login = async (e) => {
    e.preventDefault();
    toast.dismiss();
    if (this.handleLoginValidation()) {
      let apidata = {
        "email": this.state.username,
        "password": this.state.password,
      }

      let loginURL = ApiData.baseURL + `/auth/login`;
      try {
        let response = await fetch(loginURL, {
          method: 'POST',
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(apidata),
        });
        let data = await response.json().catch(() => null);
        if (response.ok && data?.token) {
          localStorage.setItem('token', data.token.accessToken);
          localStorage.setItem('userData', JSON.stringify(data.user));
          this.setState({
            username: '',
            password: '',
            errors: {},
          });
          window.location = "?page=Trips";
        }
        else {
          this.setState({ errors: { username: '*', password: '*' } });
          toast.error(data?.message === 'error.userNotFound'
            ? 'Invalid email or password'
            : (data?.message || 'Login failed. Please try again.'));
        }
      } catch (err) {
        toast.error('Unable to reach the server. Please try again.');
      }
    }
    else {
      toast.error('Missing Information / Fields');
    }
  }

  render() {
    return (
      <div>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
        />
        <ToastContainer />
        <table cellPadding="10" className="viewdata">
          <tbody>
            <tr>
              <td colSpan="4">
                <div className="model_html_login">
                  <div>
                    <img src="https://planmytrip-assets.s3.amazonaws.com/assets/resources/images/EX_logo.png" alt="" />
                  </div>
                  <table cellPadding="8">
                    <tbody>
                      <tr>
                        <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                          <label>Username</label><br />
                          <TextField
                            id="txtSNTitle"
                            size="small"
                            style={{ width: '300px' }}
                            variant="outlined"
                            value={this.state.username}
                            error={!!this.state.errors['username']}
                            onChange={(event) =>
                              this.setState({ username: event.target.value })
                            }
                          />
                        </td>
                      </tr>

                      <tr>
                        <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                          <label>Password</label><br />
                          <TextField
                            id="txtSNTitle"
                            size="small"
                            type="password"
                            variant="outlined"
                            style={{ width: '300px' }}
                            value={this.state.password}
                            error={!!this.state.errors['password']}
                            onChange={(event) =>
                              this.setState({ password: event.target.value })
                            }
                          /><br />
                          {/*   <span className="errorMsg">{this.state.errors['password']}</span> */}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="4">
                          <Button
                            id="btnSaveSN"
                            variant="contained"
                            color="primary"
                            onClick={this.Login.bind(this)}
                          >
                            Login
                          </Button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="4">
                <div className="borderDiv" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default Login;


